export enum OrientationTypes {
  Landscape = "landscape",
  LandscapeSidebar = "landscape-sidebar",
  Portrait = "portrait"
}